import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AuthLayout } from '@/components/auth/AuthLayout';
import { MagicLinkForm } from '@/components/auth/MagicLinkForm';

const searchSchema = z.object({
  redirect: z.string().optional(),
});

export const Route = createFileRoute('/sign-up')({
  validateSearch: searchSchema,
  component: SignUpPage,
});

function SignUpPage() {
  const { redirect } = Route.useSearch();
  return (
    <AuthLayout
      eyebrow="Create your account"
      title="Start with chainMuse."
      subtitle="Enter your email. We'll send a confirmation link, then walk you through one quick setup — choosing whether your account is for an artist, gallery, auction house, or yourself."
    >
      <MagicLinkForm intent="sign-up" redirectTo={redirect ?? '/app/onboarding'} />
    </AuthLayout>
  );
}
